import { News } from '../types';

export interface NewsNotifications {
  newsNotifications: News[];
}

export class NewsNotifications implements NewsNotifications {}
